import { render } from "./AdminCompanyPermissions.vue?vue&type=template&id=9eb1cc86&scoped=true"
import script from "./AdminCompanyPermissions.vue?vue&type=script&lang=js"
export * from "./AdminCompanyPermissions.vue?vue&type=script&lang=js"

import "./AdminCompanyPermissions.vue?vue&type=style&index=0&id=9eb1cc86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb1cc86"]])

export default __exports__